import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@shared/constants/languages.ts';
import { useContentLanguage } from '../../i18n/localized.ts';
import type { TranslationDraft } from '../localized-fields.tsx';
import { TextInput } from '../ui.tsx';

interface Props {
  baseLanguage: SupportedLanguage;
  value: TranslationDraft;
  onChange: (language: SupportedLanguage, value: string) => void;
}

/** Optional staff-facing names for the same payment method. */
export default function PaymentMethodTranslations({ baseLanguage, value, onChange }: Props) {
  const { t } = useTranslation();
  const readingIn = useContentLanguage();
  return (
    <div className="max-w-xl">
      {SUPPORTED_LANGUAGES.filter((language) => language !== baseLanguage).map((language) => {
        let languageName: string = language;
        try {
          languageName = new Intl.DisplayNames([readingIn], { type: 'language' }).of(language) ?? language;
        } catch {
          // A missing Intl implementation must not hide an editable name.
        }
        return (
          <TextInput
            key={language}
            label={t('paymentMethods.translationLabel', { language: languageName })}
            hint={t('paymentMethods.translationHint', { language: languageName })}
            value={value[language]}
            onChange={(event) => onChange(language, event.target.value)}
          />
        );
      })}
    </div>
  );
}
